import { TableData } from '../../Screens/Company/Company.styled';
import { KEYWORDS_PLACEHOLDER } from '../Company/KeywordTable.component';

const KeywordListTableComponent = (props: any) => {
	return (
		<div>
			<div className="table-container bg-white rounded">
				<div className="table-scrollable d-flex">
					<div className="text-center p-4 w-100 fs-10 fw-500">
						<TableData>{KEYWORDS_PLACEHOLDER}</TableData>
					</div>
				</div>
			</div>
		</div>
	);
};

export default KeywordListTableComponent;
